<template>
     <div class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-6" >
         <div class="row align-center">
            <div class="col-2 col-sm-1 py-0 pl-5  pl-md-5 text-center rounded">
                <img :src="`${domain}img/web_commerce/${servicio.sedeImg}`" class="img-dialog-description">
            </div>
            <div class="col-10 col-sm-11 pt-2 pl-10  pl-md-0 orange--text">
                <h1 class="font-weight-black orange--text col font-title" style="line-height:.5"><i>{{ servicio.service }}</i></h1>
                <h1 class='graylight--text col font-title' style="line-height:.5">Sede {{ servicio.sedeName }}</h1>
            </div>
        </div>
        <v-col cols="12" class="grayblack--text font-text"  style="display: inline-block" v-html="servicio.sedeDescription" />
        <v-col cols="12">
            <v-responsive >
                <iframe 
                :src="servicio.sedeUrlMaps" 
                width="800" 
                height="300" 
                style="border:0;border-radius: 10px;" 
                allowfullscreen="" 
                loading="lazy"
            ></iframe>
            </v-responsive>
        </v-col>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'ServiceComponent',
    props:{
        servicio:{
            type : Object,
            default: () => {}
        }
    },
    data:()=>({
       
        domain: process.env.VUE_APP_NODE_ENV === "production" ? process.env.VUE_APP_API_URL_PROD : process.env.VUE_APP_API_URL_DEVEL,
    }),
    computed:{

        ...mapState(['dataWeb'])

    },
    mounted(){
        console.log('this.servicio', this.servicio)
    }

}
</script>

<style>

</style>